import { Component } from '@angular/core';

@Component({
  selector: 'ltg-reset-password-invalid',
  templateUrl: './reset-password-invalid.component.html',
  styleUrls: ['./reset-password-invalid.component.css']
})
export class ResetPasswordInvalidComponent { }



// WEBPACK FOOTER //
// /var/www/lantago-app/lantago-app-demo/src/app/auth/reset-password/reset-password-invalid/reset-password-invalid.component.ts